import React, { useState } from "react";
import "./faq.css"; // Assuming the CSS is in this file
import { FaPlus } from "react-icons/fa6";

const FAQSection = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ((prev) => (prev === index ? null : index));
  };

  return (
    <div className="faq">
      <ul className="faq-list">
        {[
          {
            question: "What is Bhookr?",
            answer:
              "Bhookr is a cloud kitchen specializing in healthy, calorie-counted meals tailored to fit your nutritional needs. We offer a diverse menu with subscription plans and single-order options for breakfast, lunch, and dinner.",
          },
          {
            question: "How do I subscribe to Bhookr?",
            answer:
              "Subscribing to Bhookr is simple! Visit our website, choose your desired meal plan, and follow the prompts to create your account. You can customize your meals based on your dietary preferences.",
          },
          {
            question: "Can I customize my meals?",
            answer:
              "Absolutely! At Bhookr, we understand that everyone has unique dietary needs. You can customize your meals by selecting ingredients, portion sizes, and specific dietary options, such as vegan or gluten-free.",
          },
          {
            question: "What meal plans do you offer?",
            answer:
              "We offer various meal plans, including vegetarian, non-vegetarian, and vegan options. Our plans cater to different calorie requirements and preferences, ensuring there's something for everyone.",
          },
          {
            question: "How are the meals prepared?",
            answer:
              "All Bhookr meals are prepared fresh daily using high-quality ingredients. Our team of culinary experts ensures that each meal is not only nutritious but also delicious, providing you with the best possible dining experience.",
          },
          {
            question: "What is the delivery process?",
            answer:
              "We partner with reliable delivery services like Zomato and Swiggy for seamless meal delivery. Once you place your order, you can track its progress in real-time until it arrives at your doorstep.",
          },
          {
            question: "Are the meals healthy?",
            answer:
              "Yes! Bhookr focuses on providing hot and fresh meals that are calorie and protein counted. Each meal is designed to meet your nutritional needs without compromising on taste.",
          },
          {
            question: "How can I manage my subscription?",
            answer:
              "You can easily manage your subscription through your account on our website. Here, you can pause, modify, or cancel your subscription, as well as update your meal preferences.",
          },
          {
            question: "Do you offer refunds or cancellations?",
            answer:
              "Yes, we have a flexible cancellation policy. If you wish to cancel your subscription, please do so within the specified timeframe to receive a full refund for any unfulfilled meals.",
          },
          {
            question: "How can I contact customer support?",
            answer:
              "Our customer support team is here to help! You can reach out to us via the 'Contact Us' page on our website, where you can fill out a form or find our contact information for direct inquiries.",
          },
        ].map((faq, index) => (
          <li
            key={index}
            data-aos="fade-up"
            data-aos-delay={100 * (index + 1)}
            className={`aos-init aos-animate ${
              activeFAQ === index ? "open" : ""
            }`}
          >
            <button
              className="faq-toggle"
              onClick={() => toggleFAQ(index)}
              aria-expanded={activeFAQ === index}
            >
              {faq.question}{" "}
              <FaPlus
                className={`fas fa-arrow-up ${
                  activeFAQ === index ? "rotate" : ""
                }`}
              />
            </button>
            <div id={`faq${index}`} className="collapse">
              {activeFAQ === index && <p>{faq.answer}</p>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FAQSection;
